import React, { useState } from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Divider,
  Typography,
  IconButton,
  Tooltip,
} from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import { GrRobot } from "react-icons/gr";
import { GrCompare } from "react-icons/gr";
import SearchIcon from '@mui/icons-material/Search';
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';


const CollapsibleSidebar = () => {
  // State to toggle the entire sidebar
  const [collapsed, setCollapsed] = useState(true);

  // Toggle sidebar visibility
  const handleToggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Box
      sx={{
        width: collapsed ? '40px' : '400px', // Collapsed vs expanded width
        height: '100vh',
        backgroundColor: '#2c4d78', // Dark navy blue
        color: 'white',
        padding: '15px',
        boxShadow: '2px 0 5px rgba(0, 0, 0, 1)', // Soft shadow
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.3s ease', // Smooth transition for collapsing
      }}
    >
      {/* Toggle Button */}
      <Box
        sx={{
          display: 'flex',
          justifyContent: collapsed ? 'center' : 'flex-end',
          marginBottom: '16px',
        }}
      >
        <Tooltip title={collapsed ? 'Expand' : 'Collapse'}>
          <IconButton onClick={handleToggleSidebar} sx={{ color: 'white' }}>
            {collapsed ? <MenuIcon /> : <CloseIcon />}
          </IconButton>
        </Tooltip>
      </Box>

      {/* Header */}
      {!collapsed && (
        <Typography variant="h6" sx={{ fontWeight: 'bold', marginBottom: '16px' }}>
          Tools
        </Typography>
      )}

      {/* Tool List (Always Expanded) */}
      <List component="nav">
        {/* Tool 1: Batch Question Requests */}
        <ListItem
          button
          component="a"
          href="/batch_ask?mode=knowledge" // Adjust to match your routes
          sx={{
            pl: collapsed ? 0 : 2, // Padding adjusts when collapsed
            textDecoration: 'none',
            color: 'white', // White text
          }}
        >
          <DashboardIcon sx={{ marginRight: collapsed ? 0 : 1 }} />
          {!collapsed && <ListItemText primary="Batch Ask Knowledge Requests" />}
        </ListItem>

                {/* Tool 1: Batch Question Requests */}
                <ListItem
          button
          component="a"
          href="/batch_ask?mode=gpt" // Adjust to match your routes
          sx={{
            pl: collapsed ? 0 : 2, // Padding adjusts when collapsed
            textDecoration: 'none',
            color: 'white', // White text
          }}
        >
          <GrRobot style={{ marginRight: collapsed ? 0 : 8, fontSize: 20 }} />
          {!collapsed && <ListItemText primary="Batch Ask ChatGPT" />}
        </ListItem>

                        {/* Tool 3: Answer comparison */}
                        <ListItem
          button
          component="a"
          href="/answer_comparison" // Adjust to match your routes
          sx={{
            pl: collapsed ? 0 : 2, // Padding adjusts when collapsed
            textDecoration: 'none',
            color: 'white', // White text
          }}
        >
          <GrCompare style={{ marginRight: collapsed ? 0 : 8, fontSize: 20 }} />
          {!collapsed && <ListItemText primary="Answer comparison" />}
        </ListItem>

        

        {/* Tool 2: Placeholder for Vector DB Search */}
        <ListItem
          button
          sx={{
            pl: collapsed ? 0 : 2,
            opacity: 0.5, // Dimmed for "Coming Soon"
            cursor: 'not-allowed',
            textDecoration: 'none',
            color: 'white',
          }}
        >
          <SearchIcon sx={{ marginRight: collapsed ? 0 : 1 }} />
          {!collapsed && <ListItemText primary="Vector DB Search" />}
        </ListItem>
      </List>

      {/* Divider */}
      <Divider sx={{ marginY: 2, backgroundColor: 'rgba(255, 255, 255, 0.3)' }} />

      {/* Footer */}
      {!collapsed && (
        <Typography variant="body2" sx={{ marginTop: 'auto', opacity: 0.8 }}>
          Aquant Success Suite
        </Typography>
      )}
    </Box>
  );
};

export default CollapsibleSidebar;